import React from 'react';

export default function DisplayModeToggle({ mode, setMode }) {
  const cycle = () => {
    const next = mode === 'table' ? 'medium' : mode === 'medium' ? 'large' : 'table';
    setMode(next);
  };

  const icon = mode === 'table' ? '📄' : mode === 'medium' ? '🖼️' : '🖼️+';

  return (
    <button type="button" className="btn btn-outline-secondary me-2" onClick={cycle}>
      {icon}
    </button>
  );
}
